import React from 'react'
import { Script } from "gatsby"

const Scripts = () => {
  return (
    <>
      {/*
        OneTrust (OtAutoBlock.js + otSDKStub.js + OptanonWrapper) is injected
        into the SSR <head> in gatsby-ssr.js — see ./oneTrust.ts. It must load
        before every other script for auto-block to intercept them.
      */}

      {/* ACCESSIBE */}

      <Script key="AccessiBe">
        {`
          (function(){
            var s    = document.createElement('script');
            var h    = document.querySelector('head') || document.body;
            s.src    = 'https://acsbapp.com/apps/app/dist/js/app.js';
            s.async  = true;
            s.onload = function(){
                acsbJS.init({
                    statementLink    : '',
                    footerHtml       : '',
                    hideMobile       : false,
                    hideTrigger      : false,
                    disableBgProcess : false,
                    language         : 'en',
                    position         : 'left',
                    leadColor        : '#1e1e1e',
                    triggerColor     : '#1e1e1e',
                    triggerRadius    : '50%',
                    triggerPositionX : 'left',
                    triggerPositionY : 'bottom',
                    triggerIcon      : 'people',
                    triggerSize      : 'medium',
                    triggerOffsetX   : 20,
                    triggerOffsetY   : 20,
                    mobile           : {
                        triggerSize      : 'small',
                        triggerPositionX : 'left',
                        triggerPositionY : 'bottom',
                        triggerOffsetX   : 10,
                        triggerOffsetY   : 10,
                        triggerRadius    : '50%'
                    }
                });
            };
            h.appendChild(s);
          })();
        `}
      </Script>
    </>
  )
}

export default Scripts;
